// Policies hub — client for GET /v1/orgs/:orgId/policy-inventory.

import { jsonOrThrow } from '../../lib/apiError';
import type { PolicyInventory } from './catalog';

const API_URL = import.meta.env.VITE_API_URL ?? 'http://localhost:8080';

export async function getPolicyInventory(idToken: string, orgId: string): Promise<PolicyInventory> {
  const res = await fetch(`${API_URL}/v1/orgs/${encodeURIComponent(orgId)}/policy-inventory`, {
    headers: { authorization: `Bearer ${idToken}` },
  });
  return jsonOrThrow<PolicyInventory>(res);
}
